/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ labels: NonNullable<unknown> }} List_Filter_All_ExceptInputs */

const vi_list_filter_all_except = /** @type {(inputs: List_Filter_All_ExceptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tất cả trừ ${i?.labels}`)
};

/**

* @param {List_Filter_All_ExceptInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const list_filter_all_except = /** @type {((inputs: List_Filter_All_ExceptInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<List_Filter_All_ExceptInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_list_filter_all_except(inputs)
});